var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43949 22.7208C6.71986 23.1405 8.12749 22.8502 9.08086 21.8968C10.4466 20.531 10.4506 18.2132 8.95592 16.7184C7.46121 15.2237 5.14332 15.2277 3.77756 16.5935C2.82419 17.5469 2.53384 18.9545 2.95357 20.2349L4.52254 18.6659C5.20901 17.9794 6.322 17.9794 7.00846 18.6659C7.69493 19.3524 7.69493 20.4654 7.00846 21.1518L5.43949 22.7208ZM4.05284 22.5652C3.92943 23.0198 4.09154 23.5104 4.56283 23.7206C6.37058 24.5268 8.52558 24.2198 9.96474 22.7807C11.8484 20.8971 11.7924 17.7872 9.83981 15.8346C7.88718 13.8819 4.7773 13.826 2.89368 15.7096C1.45452 17.1488 1.14759 19.3038 1.95377 21.1115C2.16394 21.5828 2.65455 21.7449 3.10913 21.6215C3.30484 21.5684 3.49388 21.4623 3.65098 21.3052L5.40643 19.5498C5.60474 19.3515 5.92627 19.3515 6.12458 19.5498C6.32289 19.7481 6.32289 20.0696 6.12458 20.2679L4.36913 22.0234C4.21203 22.1805 4.10597 22.3695 4.05284 22.5652ZM5.25185 22.9087L5.25298 22.9073L5.25185 22.9087Z",
    fill: "url(#paint0_linear_2484_51293)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79486 17.6474C9.55078 17.4033 9.55079 17.0076 9.79486 16.7635L10.768 15.7904C11.0121 15.5463 11.4078 15.5463 11.6519 15.7904C11.8959 16.0344 11.8959 16.4302 11.6519 16.6742L10.6787 17.6474C10.4347 17.8914 10.0389 17.8914 9.79486 17.6474Z",
    fill: "url(#paint1_linear_2484_51293)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02709 15.8798C7.78302 15.6357 7.78302 15.24 8.02709 14.9959L9.8897 13.1333C10.1338 12.8892 10.5295 12.8892 10.7736 13.1333C11.0177 13.3774 11.0177 13.7731 10.7736 14.0172L8.91098 15.8798C8.6669 16.1239 8.27117 16.1239 8.02709 15.8798Z",
    fill: "url(#paint2_linear_2484_51293)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3144 1.87333C20.034 1.45361 18.6264 1.74395 17.673 2.69733C16.3073 4.06308 16.3032 6.38097 17.798 7.87568C19.2927 9.37039 21.6106 9.36638 22.9763 8.00063C23.9297 7.04725 24.22 5.63962 23.8003 4.35926L22.2313 5.92823C21.5449 6.6147 20.4319 6.61469 19.7454 5.92823C19.0589 5.24176 19.0589 4.12877 19.7454 3.4423L21.3144 1.87333ZM22.701 2.02889C22.8244 1.57431 22.6623 1.0837 22.1911 0.873531C20.3833 0.0673527 18.2283 0.374282 16.7891 1.81344C14.9055 3.69706 14.9615 6.80695 16.9141 8.75957C18.8667 10.7122 21.9766 10.7681 23.8602 8.88451C25.2994 7.44535 25.6063 5.29035 24.8001 3.48259C24.5899 3.01131 24.0993 2.84919 23.6448 2.9726C23.449 3.02574 23.26 3.1318 23.1029 3.28889L21.3475 5.04434C21.1491 5.24266 20.8276 5.24266 20.6293 5.04434C20.431 4.84603 20.431 4.5245 20.6293 4.32619L22.3847 2.57074C22.5418 2.41364 22.6479 2.2246 22.701 2.02889ZM21.502 1.68547L21.5009 1.68683L21.502 1.68547Z",
    fill: "url(#paint3_linear_2484_51293)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7268 8.71426C18.4827 8.47018 18.087 8.47018 17.8429 8.71426L16.8698 9.68737C16.6257 9.93145 16.6257 10.3272 16.8698 10.5713C17.1139 10.8153 17.5096 10.8153 17.7537 10.5713L18.7268 9.59814C18.9709 9.35406 18.9709 8.95833 18.7268 8.71426Z",
    fill: "url(#paint4_linear_2484_51293)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.959 6.94668C16.7149 6.7026 16.3192 6.7026 16.0751 6.94668L14.2125 8.80928C13.9684 9.05336 13.9684 9.44909 14.2125 9.69317C14.4566 9.93725 14.8523 9.93725 15.0964 9.69317L16.959 7.83056C17.2031 7.58648 17.2031 7.19075 16.959 6.94668Z",
    fill: "url(#paint5_linear_2484_51293)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68953 4.81406L5.80565 5.69794L14.0069 13.8992L14.8908 13.0153L6.68953 4.81406Z",
    fill: "url(#paint6_linear_2484_51293)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8225 14.6054L20.9461 21.729C21.4363 22.2192 22.2311 22.2192 22.7214 21.729C23.2116 21.2387 23.2116 20.4439 22.7214 19.9536L15.5978 12.8301L13.8225 14.6054ZM12.807 13.8532C12.3915 14.2686 12.3915 14.9422 12.807 15.3576L20.0622 22.6128C21.0406 23.5912 22.6269 23.5912 23.6053 22.6128C24.5837 21.6344 24.5837 20.0482 23.6053 19.0698L16.3501 11.8146C15.9346 11.3991 15.261 11.3991 14.8456 11.8146L12.807 13.8532Z",
    fill: "url(#paint7_linear_2484_51293)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.652823 6.92274C0.0336935 6.30361 0.0336949 5.2998 0.652824 4.68067L0.751925 4.58157C1.13665 4.19685 1.68474 4.02378 2.22063 4.11781C2.35519 4.14142 2.49281 4.09797 2.58942 4.00137L4.76748 1.8233C5.98398 0.606809 7.43046 0.373353 8.66857 0.560871C9.8779 0.744029 10.9284 1.33106 11.4729 1.83366C11.663 2.00912 11.7254 2.28355 11.6298 2.52393C11.5342 2.7643 11.3003 2.92093 11.0417 2.91788C9.02118 2.89409 8.02668 4.21694 7.74907 5.01307C7.64716 5.30533 7.48993 5.69852 7.17641 6.01204L5.88825 7.3002C5.79165 7.3968 5.74819 7.53443 5.7718 7.66899C5.86583 8.20488 5.69277 8.75297 5.30805 9.13769L5.20894 9.23679C4.58982 9.85592 3.58601 9.85592 2.96688 9.23679L0.652823 6.92274ZM1.53671 6.03885L3.85076 8.35291C3.98174 8.48388 4.19409 8.48388 4.32506 8.35291L4.42416 8.25381C4.52077 8.1572 4.56422 8.01958 4.54061 7.88502C4.44658 7.34913 4.61965 6.80104 5.00437 6.41631L6.29252 5.12816C6.3945 5.02618 6.47721 4.86408 6.56877 4.6015C6.8714 3.73361 7.71181 2.5307 9.21048 1.97348C8.9812 1.89719 8.73617 1.83536 8.48139 1.79678C7.55067 1.65581 6.53116 1.82739 5.65136 2.70719L3.4733 4.88525C3.08858 5.26997 2.54049 5.44303 2.0046 5.349C1.87004 5.32539 1.73241 5.36885 1.63581 5.46545L1.53671 5.56455C1.40573 5.69553 1.40573 5.90788 1.53671 6.03885Z",
    fill: "url(#paint8_linear_2484_51293)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2484_51293",
    x1: 1.04484,
    y1: -4.22297,
    x2: 30.8408,
    y2: -1.86071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#FCE57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB077"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTeam);
export default __webpack_public_path__ + "static/media/yellow_team.049bfd347d79058ef54ed44277cff5d8.svg";
export { ForwardRef as ReactComponent };